/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1EnvironmentsGetEnvironmentRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
};

/** @internal */
export type V1EnvironmentsGetEnvironmentRequestBody$Outbound = {
  project: string;
  app: string;
  environment: string;
};

/** @internal */
export const V1EnvironmentsGetEnvironmentRequestBody$outboundSchema: z.ZodType<
  V1EnvironmentsGetEnvironmentRequestBody$Outbound,
  z.ZodTypeDef,
  V1EnvironmentsGetEnvironmentRequestBody
> = z.object({
  project: z.string(),
  app: z.string(),
  environment: z.string(),
});

export function v1EnvironmentsGetEnvironmentRequestBodyToJSON(
  v1EnvironmentsGetEnvironmentRequestBody:
    V1EnvironmentsGetEnvironmentRequestBody,
): string {
  return JSON.stringify(
    V1EnvironmentsGetEnvironmentRequestBody$outboundSchema.parse(
      v1EnvironmentsGetEnvironmentRequestBody,
    ),
  );
}
